var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('v-icon',{staticClass:"float-left"},[_vm._v(" mdi-chevron-left ")]),_c('v-breadcrumbs',{staticClass:"float-left pa-0 breadcrumbs",attrs:{"items":_vm.items,"divider":_vm.divider}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }